// extracted by mini-css-extract-plugin
export default {"textButton":"TextButton_textButton__sGIYO","buttonTitle":"TextButton_buttonTitle__9mIAH","buttonTitleUnderline":"TextButton_buttonTitleUnderline__k-BLa"};